'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';

export const componentName = 'FooterKYC';

export enum OFFICIAL_FOOTER_KYC_KEY {
    KYC = 'official-site-footer-kyc-area',
}

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.FOOTER_KYC_AREA,
    name: componentName,
    enable: true,
    editable: true,
    next: null,
    deletable: false,
};

export const features = [
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.FONT_FAMILY,
    FEATURE_FLAG_KEYS.FONT_SIZE,
    FEATURE_FLAG_KEYS.FONT_WEIGHT,
    FEATURE_FLAG_KEYS.FONT_COLOR,
    FEATURE_FLAG_KEYS.TEXT_ALIGNMENT,
    FEATURE_FLAG_KEYS.TEXT_LINE_HEIGHT,
    FEATURE_FLAG_KEYS.TEXT_LETTER_SPACING,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.FONT_FAMILY]: 'Inter',
    [FEATURE_FLAG_KEYS.FONT_WEIGHT]: '400',
    [FEATURE_FLAG_KEYS.FONT_SIZE]: 'custom',
    [FEATURE_FLAG_KEYS.FONT_SIZE_CUSTOM]: '12',
    [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(57, 57, 62, 1)',
    [FEATURE_FLAG_KEYS.TEXT_ALIGNMENT]: 'right',
} as const;

export function createFooterKYC(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}
